import { defineStore } from "pinia";
import axios from "axios";
import { apiAction } from "@/store/helpers.js";
import { SUBMISSION_ENDPOINTS } from "@/api/submission.endpoints.js";

export const useSubmissionStore = defineStore("submission", {
  state: () => ({
    isLoading: false,
    error: null,
  }),

  actions: {
    async submit(payload) {
      return apiAction(this, () => axios.post(SUBMISSION_ENDPOINTS.submit, payload));
    },
  },
});
